import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isAuthenticated, isWhiteListedRoute } from '@/utils/auth';

interface AuthGuardProps {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const authed = isAuthenticated();
  const whiteListed = isWhiteListedRoute(location.pathname);

  useEffect(() => {
    if (authed && location.pathname === '/login') {
      navigate('/', { replace: true });
    } else if (!authed && !whiteListed) {
      navigate('/login', { replace: true });
    }
    setChecking(false);
  }, [authed, whiteListed, location.pathname, navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f0f2f5]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[#122c52] border-t-transparent rounded-full animate-spin"></div>
          <span className="text-sm text-gray-400">加载中...</span>
        </div>
      </div>
    );
  }

  if (location.pathname === '/login' && authed) {
    return null;
  }

  if (!authed && !whiteListed) {
    return null;
  }

  return <>{children}</>;
}
